module.exports = __webpack_public_path__ + "static/media/Cirina.eb0ff5b6.md";